module.exports = __webpack_public_path__ + "img/T4-D-xs_16.91dd1b27.png";